import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyBXSdh8nNHf0aOVin0OufCOUiiEGqVdU-8",
  authDomain: "parkingpal-app.firebaseapp.com",
  databaseURL: "https://parkingpal-app-default-rtdb.firebaseio.com",
  projectId: "parkingpal-app",
  storageBucket: "parkingpal-app.appspot.com",
  messagingSenderId: "705116175995",
  appId: "1:705116175995:web:6d2ff019a32d444f3a6cde"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export { db };